import script from "./InvoicingDisplayFieldsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoicingDisplayFieldsTable.vue?vue&type=script&setup=true&lang=ts"

import "./InvoicingDisplayFieldsTable.vue?vue&type=style&index=0&id=90410118&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90410118"]])

export default __exports__